import axios from 'axios'
let baseURL = process.env.API_MIDDLEWARE;

const service = axios.create({
	baseURL,
	timeout: 30000
	//withCredentials: true
})

//service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

service.interceptors.request.use(
	config => {
		const regex = new RegExp(`(^| )${"ct"}=([^;]+)`)
		const match = document.cookie.match(regex)
		if (match) {
			config.headers.common.ct = match[2]
		}

		// let token = window.localStorage.getItem("accessToken");
		// if (token) {
		// 	//config.headers.common.Authorization = token;
		// }
		return config;
	},
	error => Promise.reject(error)
);

service.interceptors.response.use(
	response => {
		const res = response.data;

		if (response.status !== 200) {
			return Promise.reject(new Error(res.message || "Error"));
		} else {
			return Promise.resolve(res);
		}
	},
	error => {
		console.log("err" + error);
		console.log(error);
		//alert(error);
		return Promise.reject(error);
	}
);

export default service;